import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { productQueryKeys, updateEntryTeacherName } from '../api/product.api';
import type { EntryTeacherNamePayload } from '../types/product.types';

interface UpdateEntryTeacherNameArgs {
  entryId: number;
  payload: EntryTeacherNamePayload;
}

export function useUpdateEntryTeacherName(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ entryId, payload }: UpdateEntryTeacherNameArgs) =>
      updateEntryTeacherName(entryId, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: productQueryKeys.all() });
      toast.success('Teacher name updated');
      onSuccess?.();
    },
    onError: (error) => showApiErrorToast(error, 'Failed to update the teacher name'),
  });
}
